import { styled } from '@linaria/react';
import { StyledLandingSection } from './LandingSection';
export const StyledFeatureCloud = /*#__PURE__*/styled("div")({
  name: "StyledFeatureCloud",
  class: "s18mjt73"
});
export const LandingFeatureOverview = () => {
  return <StyledLandingSection className="featOverview" bg={'var(--bg-nav)'}>
			<div className="content">
				<div className="headline">
					<h2 className="shadow">A Desktop-Class Experience on the Web.</h2>
					<p>Optimized for modern production workflows.</p>
				</div>
				<StyledFeatureCloud>
					<div className="featurePreview">
						<div className="previewContent">
							<h4>⚡ Lightning Fast</h4>
							<p>Built solely for speed.</p>
							<p>Opens in 6 seconds.</p>
							<p>No spinners.</p>
						</div>
					</div>
					<div className="featurePreview">
						<div className="previewContent">
							<h4>✨ Magic Built-in</h4>
							<p>Collaboration & syncing.</p>
							<p>Feels like a native app.</p>
							<p>Automated audio cleanup.</p>
						</div>
					</div>
					<div className="featurePreview">
						<div className="previewContent">
							<h4>🧠 Editor Copilot</h4>
							<p>Organizes in seconds.</p>
							<p>Rates your work.</p>
							<p>Suggests edits.</p>
						</div>
					</div>
					<div className="featurePreview">
						<div className="previewContent">
							<h4>🧩 All-in-One</h4>
							<p>Multi-track timelines.</p>
							<p>Transcript editing.</p>
							<p>Audio processing & more.</p>
						</div>
					</div>
					<div className="featurePreview">
						<div className="previewContent">
							<h4>⌨️ Cross-Platform</h4>
							<p>PC. Mac.</p>
							<p>iPhone. Android.</p>
							<p>Accessible by default.</p>
						</div>
					</div>
					<div className="featurePreview">
						<div className="previewContent">
							<h4>🌤️ Works Offline</h4>
							<p>Privacy by default.</p>
							<p>Cloud-optional.</p>
							<p>Pants are optional, too.</p>
						</div>
					</div>
				</StyledFeatureCloud>
			</div>
		</StyledLandingSection>;
};

require("./LandingFeatureOverview.linaria.module.css!=!../../../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./LandingFeatureOverview.tsx");